import styled from "styled-components";
import { colors } from "../../theme";

const Alert = styled.div`
  background-color: ${colors.primary};
  padding: 10px;
  color: white;
  font-weight: bold;
`;

export default Alert;



// WEBPACK FOOTER //
// ./src/components/Alert/Alert.js